/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class CoreFormatKey {
  static readonly DATE = 'kit-core/format/date';
  static readonly LONG_DATE = 'kit-core/format/long-date';
  static readonly SHORT_DATE = 'kit-core/format/short-date';
  static readonly TIME = 'kit-core/format/time';
  static readonly PRECISE_TIME = 'kit-core/format/precise-time';
  static readonly EXACT_TIME = 'kit-core/format/exact-time';
  static readonly DATE_TIME = 'kit-core/format/date-time';
  static readonly LONG_DATE_TIME = 'kit-core/format/long-date-time';
  static readonly SHORT_DATE_TIME = 'kit-core/format/short-date-time';
  static readonly PRECISE_DATE_TIME = 'kit-core/format/date-time';
  static readonly PRECISE_LONG_DATE_TIME = 'kit-core/format/long-date-time';
  static readonly PRECISE_SHORT_DATE_TIME = 'kit-core/format/short-date-time';
  static readonly EXACT_DATE_TIME = 'kit-core/format/exact-date-time';

  static readonly UTC_DATE = 'kit-core/format/utc-date';
  static readonly UTC_LONG_DATE = 'kit-core/format/utc-long-date';
  static readonly UTC_SHORT_DATE = 'kit-core/format/utc-short-date';
  static readonly UTC_TIME = 'kit-core/format/utc-time';
  static readonly UTC_PRECISE_TIME = 'kit-core/format/utc-precise-time';
  static readonly UTC_EXACT_TIME = 'kit-core/format/utc-exact-time';
  static readonly UTC_DATE_TIME = 'kit-core/format/utc-date-time';
  static readonly UTC_LONG_DATE_TIME = 'kit-core/format/utc-long-date-time';
  static readonly UTC_SHORT_DATE_TIME = 'kit-core/format/utc-short-date-time';
  static readonly UTC_PRECISE_DATE_TIME = 'kit-core/format/utc-precise-date-time';
  static readonly UTC_PRECISE_LONG_DATE_TIME = 'kit-core/format/utc-precise-long-date-time';
  static readonly UTC_PRECISE_SHORT_DATE_TIME = 'kit-core/format/utc-precise-short-date-time';
  static readonly UTC_EXACT_DATE_TIME = 'kit-core/format/utc-exact-date-time';

  static readonly NUMBER = 'kit-core/format/number';
  static readonly NUMBER_0 = 'kit-core/format/number-0';
  static readonly NUMBER_1 = 'kit-core/format/number-1';
  static readonly NUMBER_2 = 'kit-core/format/number-2';
  static readonly NUMBER_3 = 'kit-core/format/number-3';
  static readonly NUMBER_4 = 'kit-core/format/number-4';
  static readonly NUMBER_5 = 'kit-core/format/number-5';
  static readonly DECIMAL = 'kit-core/format/decimal';
  static readonly DECIMAL_0 = 'kit-core/format/decimal-0';
  static readonly DECIMAL_1 = 'kit-core/format/decimal-1';
  static readonly DECIMAL_2 = 'kit-core/format/decimal-2';
  static readonly DECIMAL_3 = 'kit-core/format/decimal-3';
  static readonly DECIMAL_4 = 'kit-core/format/decimal-4';
  static readonly DECIMAL_5 = 'kit-core/format/decimal-5';
  static readonly PERCENT = 'kit-core/format/percent';
  static readonly PERCENT_0 = 'kit-core/format/percent-0';
  static readonly PERCENT_1 = 'kit-core/format/percent-1';
  static readonly PERCENT_2 = 'kit-core/format/percent-2';
  static readonly PERCENT_3 = 'kit-core/format/percent-3';
  static readonly PERCENT_4 = 'kit-core/format/percent-4';
  static readonly PERCENT_5 = 'kit-core/format/percent-5';
  static readonly EUR = 'kit-core/format/eur';
  static readonly EUR_SUFFIX = 'kit-core/format/eur-suffix';
  static readonly USD = 'kit-core/format/usd';
  static readonly USD_SUFFIX = 'kit-core/format/usd-suffix';
  static readonly INDENT = 'kit-core/format/indent';
  static readonly JOIN = 'kit-core/format/join';
}
